import { useEffect, useState } from 'react';
import { Checkbox, Collapse, Input, InputNumber, Select, Space, Typography } from 'antd';
import { HDate } from '@hebcal/core';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Text } = Typography;

const monthNamesHE = ['Tishrei', 'Cheshvan', 'Kislev', 'Tevet', 'Sh\'vat', 'Adar', 'Adar I', 'Adar II', 'Nisan', 'Iyyar', 'Sivan', 'Tamuz', 'Av', 'Elul'];

export default function DdnHeField({ value, onChange, isMobile }) {

    const [inputValue, setInputValue] = useState(null);
    const [afterDark, setAfterDark] = useState(false);
    const [hdateDay, setHdateDay] = useState(null);
    const [hdateMonth, setHdateMonth] = useState(null);
    const [hdateYear, setHdateYear] = useState(null);

    const isAfterDark = (_date) => {
        if (!isValidDate(_date)) return false;
        return _date.getHours() >= 23;
    };

    const setHdateByDate = (_date) => {
        if (!isValidDate(_date)) return null;
        const _hdate = new HDate(_date);
        if (_hdate) {
            setHdateDay(_hdate.getDate());
            setHdateMonth(_hdate.getMonthName());
            setHdateYear(_hdate.getFullYear());
        }
    };

    const setInputValueByHdate = () => {
        if (hdateDay === null || hdateMonth === null || hdateYear === null) return false;
        const _hdate = new HDate(hdateDay, hdateMonth, hdateYear);
        if (isValidDate(_hdate?.greg()) && _hdate.greg() !== stringToDate(inputValue)) {
            setInputValue(dateToString(_hdate.greg()));
        }
    };

    const isValidDate = (d) => d instanceof Date && !isNaN(d);

    const dateToString = (_date) => {
        _date = new Date(_date);
        return ("0" + _date.getDate()).slice(-2) + "/" + ("0" + (_date.getMonth() + 1)).slice(-2) + "/" + _date.getFullYear();
    };

    const stringToDate = (s = "") => {
        const pattern = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/;
        if (typeof s === "string" && s.match(pattern)) {
            const _date = new Date(s.slice(6), Number(s.slice(3, 5)) - 1, s.slice(0, 2));
            if (isValidDate(_date)) return _date;
        }
        return null;
    };

    const formater = (s = "") => {
        s = s.replace(/[^0-9\/]/g, '');
        if (Number(s[0]) > 3) s = "0" + s;
        if (Number(s[3]) > 1) s = s.slice(0, 3) + "0" + s.slice(3);
        if (!inputValue || inputValue?.length < s.length) {
            if (s.length >= 2 && s[2] !== "/") s = s.slice(0, 2) + "/" + s.slice(2);
            if (s.length >= 5 && s[5] !== "/") s = s.slice(0, 5) + "/" + s.slice(5);
        }
        let _s = "";
        for (let i = 0; i < s.length; i++) {
            if (s[i] === "/" && i !== 2 && i !== 5) continue;
            _s += s[i];
        }
        return _s.slice(0, 10);
    };

    useEffect(() => {
        if (value && isValidDate(new Date(value))) {
            const _date = new Date(value);
            const stringValue = dateToString(_date);
            if (_date !== stringToDate(inputValue)) {
                setInputValue(stringValue);
                setHdateByDate(_date);
                setAfterDark(isAfterDark(_date));
            }
        }
    }, [value]);

    useEffect(() => {
        const _date = stringToDate(inputValue);
        if (_date) {
            _date.setHours(afterDark ? 23 : 11, 0, 0, 0);
            setHdateByDate(_date);
            if (_date !== value && onChange) onChange(_date);
        }
    }, [inputValue, afterDark]);

    useEffect(() => {
        setInputValueByHdate();
    }, [hdateDay, hdateMonth, hdateYear]);

    return (
        <Space size={"large"} direction="row" align="start" wrap>
            <Input
                placeholder={t`20/05/2005`}
                value={inputValue}
                onChange={(e) => setInputValue(formater(e.target.value))}
                status={(inputValue?.length === 10 && !isValidDate(stringToDate(inputValue))) ? "error" : undefined}
            />

            <Collapse>
                <Collapse.Panel key={0} header={<Trans>Convertisseur hébraïque</Trans>}>
                    <Space size={"small"} align={"center"} wrap direction={isMobile ? "vertical" : "horizontal"}>
                        <InputNumber
                            min={1}
                            max={30}
                            style={{ width: 150 }}
                            addonAfter={afterDark ? "+1" : null}
                            placeholder={t`Jour hébraïque (1-30)`}
                            value={hdateDay}
                            controls={false}
                            onChange={(v) => setHdateDay(v)}
                        />

                        <Select
                            style={{ minWidth: 150 }}
                            placeholder={t`Mois hébraïque`}
                            size={"large"}
                            value={hdateMonth}
                            onChange={(v) => setHdateMonth(v)}
                            options={monthNamesHE.map(i => ({ value: i, label: i }))}
                        />

                        <InputNumber
                            style={{ minWidth: 150 }}
                            placeholder={t`Année hébraïque (5780)`}
                            value={hdateYear}
                            controls={false}
                            onChange={(v) => setHdateYear(v)}
                        />

                        <Space>
                            <Checkbox
                                checked={afterDark}
                                onChange={(e) => setAfterDark(e.target.checked)}
                            >
                                <Trans>Après la nuit (+1 jour hébraïque)</Trans>
                            </Checkbox>
                        </Space>
                    </Space>
                </Collapse.Panel>
            </Collapse>
        </Space>
    );
}
